<template>
  <div>
    <div class="t_content">
      <div style="width:400px">
      <!-- <el-upload
        class="upload-demo"
        :action="url + '/zkfz/file/addUploadFile'"
        :limit="2"
        :http-request="upLoadFile"
        :show-file-list="false"
        style="margin-right: 30px;display:inline-block"
      >
        <el-button type="primary" v-if="userType !== '53'"
          >上传对照表评审附件</el-button
        >
      </el-upload> -->
      <!-- {{userType}} -->
       <el-button type="primary" v-if="userType !== '53'" @click="handleUpload"
          >上传附件</el-button>
      <el-button type="primary" @click="goBack" style="display:inline-block">返回</el-button>
      <div style="font-weight:900;margin-top:20px">附件名称列表</div>
      <el-table
        :data="tableData"
        style="width: 100%;"
        :show-header="false"
        :max-height="600"
        class="t_scroll"
       
        ref="table"
        @row-click="handleSelClick"
        >
        <el-table-column
          prop="fileName"
          width="320">
          <template slot-scope="scope">
            <div :class="selectId===scope.row.id?'t_active':''">{{scope.row.fileName}}</div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              v-if="selectId===scope.row.id"
              @click="handleDelete(scope.row)"
              >删除</el-button>
            </template>
        </el-table-column>
      </el-table>
      </div>
      <div class="pdfContainer">
        <img
          v-if="!isHasPDF"
          src="../../static/images/u394.svg"
          alt=""
          style="width: 100%"
        />
        <div v-if="!isHasPDF" class="desc">知识点对照表PDF文件预览</div>
        <div style="text-align: center">
          <object :data="fileSrc" type="application/pdf" width="800" height="800">
            This browser does not support PDFs. Please download the PDF to view it: 
            <a :href="fileSrc">Download PDF</a>
          </object>
        </div>
      </div>
    </div>
    <el-dialog
      title="上传附件"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <el-form ref="forms" :model="attachment" :rules="attachmentRule" label-width="120px">
        <el-form-item label="上传附件名称" prop="fileName" >
          <el-input v-model="attachment.fileName" ></el-input>
        </el-form-item>
        <el-form-item label="文件">
           <!-- <el-input type="file" v-model="attachment.file" @change="uploads($event)" name="file" placeholder="--点击上传文件，支持格式PDF--"></el-input> -->
          <el-upload
            class="upload-demo"
            :action="url + '/zkfz/file/addVideoUploadFile'"
            :http-request="upLoadFile1"
            :show-file-list="true"
            :file-list="fileList"
            :on-change="handleChangeUpload"
            ref="upload"
            style="margin-right: 30px;display:inline-block"
          >
            <el-button type="primary" v-if="userType !== '53'"
              >上传附件</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfimUpload">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/courseware/checkCourseware'
import * as api2 from '@/api/courseStructure/courseStructure'
export default {
  props: ['userType'],
  data() {
    return {
      courseId: this.$route.query.id,
      courseWareId: '',
      fileSrc: '',
      isHasPDF: false,
      tableData: [],
      dialogVisible:false,
      attachment:{fileName:'',file:''}, // 附件表单
      selectId:'', // 选中id
      attachmentRule:{
        fileName:[
          { required: true, message: "附件名称不能为空", trigger: "blur" }
        ],
        file:[
          { required: true, message: "上传附件不能为空", trigger: "blur" }
        ]
      },
      formData:'',
      fileList:[],
      isClick: false,
      isJPG:false
    }
  },
  created() {
    this.getCourseWareId();
    this.flag = false;
  },
  computed: {
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  methods: {
    getCourseWareId() {
      api2.getCourseId({ courseId: this.courseId }).then(({ data }) => {
        this.courseWareId = data
        this.getUploadFileList();
        this.reviewUploadPDF();
      })
    },

    upLoadFile(param) {
      const isRoot = this.userType === '52' || this.userType === '3'
      if (!isRoot) {
        return this.$message.error('无权限')
      }
      const file = param.file
      const isJPG = file.type == 'application/pdf'
      if (!isJPG) {
        return this.$message.error('上传文件只能是pdf类型!')
      }
      const refId = this.courseId + '_' + this.courseWareId
      let formData = new FormData()
      formData.append('file', file)
      api.addUploadFile({ refId }, formData).then(({ data }) => {
        if (data.code === 100000) {
          this.reviewUploadPDF()
          this.$message.success(data.msg)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    upLoadFile1(param) {
      const isRoot = this.userType === '52' || this.userType === '3' || this.userType === '1'
      if (!isRoot) {
        return this.$message.error('无权限')
      }
      const file = param.file
      this.isJPG = file.type == 'application/pdf'
      // this.fileList = [];
      //  console.log('cancel',this.$refs['upload'].clearFiles())
      // if (!this.isJPG) {
      //   // this.$refs['upload'].clearFiles();
      //   //  this.fileList.splice(1,0)
      //   return this.$message.error('上传文件只能是pdf类型!')
      // }
      const refId = this.courseId + '_' + this.courseWareId
      let formData = new FormData()
      formData.append('file', file)
      // console.log('file', file)
      // console.log('cancel',this.fileList.length)
      if(this.fileList.length>=1){
        // this.$refs['upload'].clearFiles();
        this.fileList.splice(0,1)
        // console.log('this.fileList',this.fileList)
      }
      this.fileList.push(file)
      this.formData = formData;
      this.attachment.refId = refId;
      // api.addVideoUploadFile1({ 'refId':'942_', 'fileName':this.attachment.fileName, file:formData}, formData).then(({ data }) => {
      //   if (data.code === 100000) {
      //     // this.reviewUploadPDF()
      //     this.getUploadFileList();
      //     this.$message.success(data.msg)
      //   } else {
      //     this.$message.error(data.msg)
      //   }
      // })
    },
    reviewUploadPDF() {
      const refId = this.courseId + '_' + this.courseWareId
      api.reviewUploadPDF(refId).then(({ data }) => {
        // console.log('data',data.data.url)
        if (data.code === 100000 && data.data !== null) {
          this.fileSrc = data.data.url
          this.isHasPDF = true
        }else{
          this.isHasPDF = false;
          this.fileSrc = '';
        }
      })
    },
    goBack() {
      this.$emit('returnCourseTree')
    },
    getUploadFileList(){
      const refId = this.courseId + '_' + this.courseWareId;
      // console.log('hiihhhh',this.courseId)
      api.getUploadFileList({refId:refId,module:'ElZyVideo'}).then(res=>{
        this.tableData = res.data.data;
        // console.log('附件列表', this.tableData) 
        if(!this.isClick){
          this.handleToggle()
        }
      })
    },
    /** 点击上传按钮事件 */
    handleUpload(){
      this.dialogVisible = true;
      this.attachment.fileName = '';
      this.attachment.file = '';
      this.fileList = [];
      this.formData = '';
      this.$nextTick(() => {
        // console.log('clearValidate',  this.$refs['forms'])
        this.$refs['forms'].clearValidate();
        this.$refs['upload'].clearFiles();
      })
    },
    /** 删除 */
    handleDelete(row){
      const id = row.id;
      let _self = this;
      this.$confirm('删除该' + '"' + row.fileName + '"' + '的附件可能带来严重的数据损失，请您再次确认此操作！','删除提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        api.delUploadFile({id:id}).then(res=>{
          if(res.data.code === 100000){
            _self.getUploadFileList();
            _self.$message.success('删除成功');
            _self.reviewUploadPDF();
          }
        });
      }).then(() => {
        // console.log('yoyyy')
        // this.getList();
        
      }).catch(() => {});
    },
    /** 当前选中行 */
    handleSelClick(row){
      this.selectId = row.id;
      this.flag = true;
      api.getFileUrl({id:row.id}).then(({data})=>{
        // console.log('选中',data)
        if (data.code === 100000 && data.data !== null) {
          this.fileSrc = data.data.url
          this.isHasPDF = true
        }
      })
    },
    /** 确认上传附件 */
    handleConfimUpload(){
      let _self = this;
      this.$refs.forms.validate((valid)=>{
        // console.log('valid',valid)
        if(valid){
          if(!this.formData) return this.$message.error('请先上传附件');
          if(!this.isJPG) return this.$message.error('请上传pdf类型');
          this.attachment.fileName =  this.attachment.fileName + '.pdf';
          api.addVideoUploadFile1(this.attachment,this.formData).then(({ data }) => {
            // console.log('this.fileList',data.code)
            if (data.code === 100000) {
              // this.reviewUploadPDF()
              _self.getUploadFileList();
              _self.reviewUploadPDF();
              _self.dialogVisible = false;
              _self.$message.success(data.msg)
            } else {
              _self.$message.error(data.msg)
            }
          })
        }
      })
    },
    /** 默认选中 */
    handleToggle(){
      if(this.tableData&&this.tableData.length>0){
        this.selectId = this.tableData[this.tableData.length-1].id;
        // console.log('this.tableData[this.tableData.length-1]',this.tableData[this.tableData.length-1])
        this.$refs.table.toggleRowSelection(this.tableData[this.tableData.length-1],true)
      }
    },
    handleChangeUpload(file,fileList){
      console.log('file',file,fileList)
    }
  },
}
</script>

<style lang="scss" scoped>
.t_content{
  display:flex;
  padding: 0 30px;
  font-size: 14px;
}
.pdfContainer {
  position: relative;
  .desc {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -300%);
    font-size: 28px;
  }
}
.t_scroll::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.t_scroll::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius   : 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
  );
}
.t_scroll::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  background   : #ededed;
  border-radius: 10px;
}
.t_active{
  color: #409EFF;
}

</style>